import React, { Component } from "react";
import { CONFIG } from "../config";
import Instructions from "./instructions";
import Nav from "./nav";
import Overlays from "./overlays";
import TopNav from "./topNav";
import Compass from "./compass";
import U from "../utils";

class UI extends Component {
	constructor() {
		super();

		this.parallaxItems = [];
	}

	componentDidMount() {
		this.initParallax();
	}

	componentDidUpdate() {
		this.parallaxItems = [...document.querySelectorAll(".parallax")].map((p) => {
			return {
				div: p,
				rate: p.getAttribute("parallax-rate") ? Number(p.getAttribute("parallax-rate")) : 2,
			};
		});
	}

	initParallax() {
		this.parallaxItems = [...document.querySelectorAll(".parallax")].map((p) => {
			return {
				div: p,
				rate: p.getAttribute("parallax-rate") ? Number(p.getAttribute("parallax-rate")) : 2,
			};
		});

		window.addEventListener("mousemove", (e) => {
			const x = U.MapRange(e.clientX, 0, window.innerWidth, -1, 1);
			const y = U.MapRange(e.clientY, 0, window.innerHeight, -1, 1);

			this.parallaxItems.map((p) => {
				p.div.style.left = `${-x * p.rate}px`;
				p.div.style.top = `${-y * p.rate}px`;
			});
		});
	}

	render() {
		const CurrentView =
			this.props.currentState && this.props.currentState.ui
				? this.props.currentState.ui
				: this.props.prevState && this.props.prevState.ui
				? this.props.prevState.ui
				: null;

		return (
			<div className="ui">
				{CurrentView ? (
					<CurrentView
						currentState={this.props.currentState}
						GoToState={this.props.GoToState}
						data={this.props.data}
					/>
				) : null}
				<Overlays />
				<Compass currentState={this.props.currentState} />
				<TopNav currentState={this.props.currentState} GoToState={this.props.GoToState} />
				<Nav currentState={this.props.currentState} GoToState={this.props.GoToState} />
				<div className="content-fade-container">
					<div className="content-fade"></div>
					<div className="content-bottom-fade"></div>
					<div className="content-top-fade"></div>
					<div className="content-right-fade"></div>
				</div>
			</div>
		);
	}
}

export default UI;
